
import React from "react";

const message =
  "✦ Découvrez nos produits • 50% Offre limitée • Stock limité •";

export default function Header() {
  return (
    <header className="relative overflow-hidden bg-gradient-to-br from-[#f0cd07] to-[#ecd714] px-5 py-4 font-sans text-white shadow-lg">
      {/* Fond décoratif */}
      <div className="pointer-events-none absolute -right-24 -top-12 h-[300px] w-[300px] rounded-full bg-[radial-gradient(circle,rgba(255,107,107,0.1)_0%,transparent_70%)]" />

      <div className="pointer-events-none absolute -bottom-20 -left-24 h-[350px] w-[350px] rounded-full bg-[radial-gradient(circle,rgba(255,184,77,0.08)_0%,transparent_70%)]" />

      {/* Texte défilant */}
      <div className="relative z-10 w-full overflow-hidden">
        <div className="flex w-max animate-marquee whitespace-nowrap text-sm font-medium uppercase tracking-[2px] text-[#000000] sm:text-base">
          <span className="shrink-0 pr-8">{message}</span>
          <span className="shrink-0 pr-8" aria-hidden="true">
            {message}
          </span>
        </div>
      </div>
    </header>
  );
}
